import { ProjectNameData } from '../../models/projects/ProjectNameData';
import { useAccount } from '../../contexts/account/AccountContexts';
import { changeProjectName } from '../../services/projects/ProjectService';
import { useFilters } from '../../contexts/filters/FiltersContext';
import { FirmData } from '../../models/monitor/FirmData';

const useChangeProjectKeyword = ({ onRefresh }: { onRefresh: () => void }) => {
  const { projectResponse } = useAccount();
  const { setSelectedFirm } = useFilters();

  const changeProjectNameEvent = async (id: number, newFirmName: string) => {
    const currentProject = projectResponse?.find((project) => project.id === id);
    if (!currentProject) {
      return;
    }

    const data: ProjectNameData = {
      projectId: id,
      projectName: newFirmName.trim() || currentProject.firmName,
      projectLabel: currentProject.projectLabel,
      projectCountry: currentProject.localization,
    };

    try {
      await changeProjectName(data);
      const projectName = data.projectName;
      setSelectedFirm({ type: projectName, name: projectName } as FirmData);
    } catch (e) {
      console.error('Error changing name:', e);
    } finally {
      onRefresh();
    }
  };

  const changeProjectKeyword = (id: number, firmName: string) => {
    if (!projectResponse) {
      return;
    }

    const currentProject = projectResponse.find((project) => project.id === id);
    if (!currentProject) {
      return;
    }
    changeProjectNameEvent(id, firmName);
  };

  return { changeProjectKeyword };
};

export default useChangeProjectKeyword;
